import controller from './confirmation-order.controller';
import templateBase from './templates/confirmation-order-base.view.html';
import templateAD from './templates/confirmation-order-view-adaptative.html';

let ConfirmationOrderComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else {
        return templateBase;
    }


}

export default ConfirmationOrderComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/confirmation-order/confirmation-order.component.js
 **/